// extracted by mini-css-extract-plugin
export default {"button":"im-z","reviewSort":"jm-z"};